import React, { useState } from 'react';
import PropTypes from 'prop-types';
import toast from 'react-hot-toast';
import checkIcon from 'assets/images/icons/check.svg';
import crossGreyIcon from 'assets/images/icons/cross-grey.svg';
import AlertModal from 'components/common-components/AlertModal';
import FormLoadingButton from 'components/form-components/FormLoadingButton';
import TextField from 'components/form-components/TextField';
import FormButton from 'components/form-components/FormButton';
import { labelColors } from 'pages/tasks/utils';
import { CallAPI } from 'actions/General';
import { t } from 'i18next';

const AddTaskLabelModal = ({ show, closeModal, getUpdatedOptions }) => {
  const [values, setValues] = useState({ name: '', color: labelColors[0] });
  const [loading, setLoading] = useState(false);

  const handleChange = (name, value) => {
    setValues({ ...values, [name]: value });
  };

  const submit = async () => {
    const result = await CallAPI('ADD_TASK_LABEL', { ...values }, null, setLoading);
    if (result.status) {
      toast.success('Task label added successfully');
      closeModal();

      if (getUpdatedOptions) {
        const result = await CallAPI('GET_ALL_TASK_LABELS');
        if (result.status) {
          const options = [];
          result.data.forEach(({ _id, name }) =>
            options.push({
              value: _id,
              displayValue: name,
            }),
          );
          getUpdatedOptions(options);
        }
      }
    }
  };

  return (
    <AlertModal show={show} size='md' actionButtons={[]} noPadding>
      <div className='w-100'>
        <div className='d-flex justify-content-between p-3'>
          <span className='theme-size-1_1 theme-font-inter-semi-bold theme-text-black-1'>
            {t('text_new_label')}
          </span>
          <img
            src={crossGreyIcon}
            className='cursor-pointer svg-black'
            onClick={() => closeModal()}
          />
        </div>
        <div className='d-flex justify-content-center theme-background-white-5 py-4'>
          <div>
            <TextField
              value={values.name}
              name='name'
              handleChange={handleChange}
              displayName={'field_label'}
              placeholder={'field_placeholder_label_name'}
              classes='mb-3'
              shrink
            />
            <div className='d-flex gap-2'>
              {labelColors.map((color, i) => (
                <div
                  key={i}
                  style={{ background: color, width: '2rem', height: '2rem' }}
                  className='d-flex justify-content-center align-items-center rounded-sm cursor-pointer'
                  onClick={() => handleChange('color', color)}
                >
                  {values.color === color && <img src={checkIcon} className='h-50 svg-white' />}
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className='d-flex gap-2 justify-content-end p-3'>
          <FormButton
            text={'button_cancel'}
            variant='white-1'
            onClick={closeModal}
            minWidth
            shrink
          />
          <FormLoadingButton
            text={'button_add'}
            variant='green-1'
            onClick={submit}
            loading={loading}
            minWidth
            shrink
          />
        </div>
      </div>
    </AlertModal>
  );
};

AddTaskLabelModal.propTypes = {
  show: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  getUpdatedOptions: PropTypes.func,
};

export default AddTaskLabelModal;
